/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { ccEnum } from './CCEnum';
import CLog, { LogTypes } from './ComponentLogger';

const {ccclass, property} = cc._decorator;

@ccclass
export default class ComponentLoggerSettings extends cc.Component {

    @property({ type: ccEnum.LogTypes, visible: true })
    private _logTypes: LogTypes[] = [];

    protected start(): void
    {
        this.configureLogging();
    }

    private configureLogging(): void
    {
        if (this._logTypes.length < 1)
        {
            // Leave at default logging.
            return;
        }

        let logTypes: LogTypes = 0;

        // Add flag for each type.
        // tslint:disable-next-line:no-bitwise
        this._logTypes.forEach(x => logTypes = logTypes | x);

        CLog.setLogTypes(logTypes);
    }
}
